import { render, staticRenderFns } from "./widget_actuals_by_status.vue?vue&type=template&id=50a6b5dc&"
import script from "./widget_actuals_by_status.vue?vue&type=script&lang=js&"
export * from "./widget_actuals_by_status.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports